import { render, staticRenderFns } from "./redemptionDetail.vue?vue&type=template&id=0501bbd6&scoped=true&"
import script from "./redemptionDetail.vue?vue&type=script&lang=js&"
export * from "./redemptionDetail.vue?vue&type=script&lang=js&"
import style0 from "./redemptionDetail.vue?vue&type=style&index=0&id=0501bbd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0501bbd6",
  null
  
)

export default component.exports